import { render, staticRenderFns } from "./CustomFieldModal.vue?vue&type=template&id=2f381e6a&scoped=true"
import script from "./CustomFieldModal.vue?vue&type=script&lang=js"
export * from "./CustomFieldModal.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldModal.vue?vue&type=style&index=0&id=2f381e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f381e6a",
  null
  
)

export default component.exports